import React from "react";
import WideContainer from "../../components/WideContainer";
import CircularProgress from "@mui/material/CircularProgress";
import DoneIcon from "@mui/icons-material/Done";
import RefreshIcon from "@mui/icons-material/Refresh";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import GetAppIcon from "@mui/icons-material/GetApp";
import ErrorIcon from "@mui/icons-material/Error";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import ReorderIcon from "@mui/icons-material/Reorder";
import AppsIcon from "@mui/icons-material/Apps";
import { Trans, withTranslation } from "react-i18next";

import axios from "../../components/Axios";
import "../Videos.css";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      loading: false,
      filter: "",
      filtered: [],
      menuVid: 0,
      menuAnchor: null,
      display: "grid", //table or grid
    };

    this.timeout = null;
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    let u = localStorage.getItem("user_id");
    if (u === null) {
      this.props.history.push("/login");
      return;
    }

    this.setState({ loading: true });
    axios
      .get(
        "/video_project/" +
        this.props.project.project_id +
        "/videos?video_type=ALL"
      )
      .then(
        function (response) {
          response.data = response.data.filter((i) =>
            ["REDACTION", "EXTRACTION"].includes(i.video_type)
          );

          this.setState({
            loading: false,
            items: response.data,
            filtered: response.data,
          });

          for (var i in response.data) {
            if (response.data[i].status === "PROCESSING") {
              this.timeout = setTimeout(() => {
                this.componentDidMount();
              }, 10000);
              break;
            }
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
          this.setState({ loading: false });
        }.bind(this)
      );
  }

  componentWillUnmount() {
    if (this.timeout !== null) clearTimeout(this.timeout);
  }

  handleChange(e, v) {
    if (v !== null) {
      this.setState({
        filter: v,
        filtered:
          v === ""
            ? this.state.items
            : this.state.items.filter((i) => {
              if (v === "ERROR")
                return !["PROCESSING", "PROCESSED"].includes(i.status);
              return i.status === v;
            }),
      });
    }
  }

  toggleView() {
    this.setState({
      display: this.state.display === "grid" ? "table" : "grid",
    });
  }

  formatFields(v, f) {
    if (f === "status") {
      let dic = {
        PROCESSING: "Processing",
        PROCESSED: "Finished",
        NOT_PROCESSED: "Not Processed",
      };
      if (v in dic) return dic[v];
      else return v;
    }
    if (f === "icon") {
      let dic = {
        PROCESSING: <RefreshIcon />,
        PROCESSED: <DoneIcon />,
        NOT_PROCESSED: <RefreshIcon />,
      };
      if (v in dic) return dic[v];
      else return <RefreshIcon />;
    }

    if (f === "created_at") {
      let d = new Date(v * 1000);
      let s = d.toDateString().split(" ");
      return (
        <span title={d.toLocaleTimeString("en-US")}>
          {s[1] + " " + s[2] + ", " + s[3]}
        </span>
      );
    }
  }

  getFormat(i) {
    let p = i.split(".");
    return "." + p.pop();
  }

  getIcon(i) {
    switch (i.status) {
      case "PROCESSING":
        return <RefreshIcon />;
      default:
        return <ErrorIcon />;
    }
  }

  downloadExtract(i) {
    window.open(i.download_path, "_blank");
  }

  menuClick(id, e) {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ menuAnchor: e.currentTarget, menuVid: id });
  }
  menuClose() {
    this.setState({ menuAnchor: null });
  }
  deleteProject() {
    this.setState({ menuAnchor: null });
    axios
      .delete("/video/" + this.state.menuVid)
      .then(
        function (response) {
          this.componentDidMount();
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error.response);
          alert(error.response.data.title);
          //this.setState({ loading: false });
        }.bind(this)
      );
  }
  downloadThumbnail() {
    for (let o of this.state.items) {
      if (o.video_id === this.state.menuVid) {
        window.open(
          o.thumbnail_path +
          '?response-content-disposition=attachment;%20filename="' +
          encodeURIComponent(o.video_name) +
          '.jpg"'
        );
      }
    }
  }

  render() {
    return (<>
      <div className="clipBar">
        <WideContainer
          style={{ display: "flex", alignItems: "center" }}
        >
          <div className="clipCount">
            <b style={{ color: "#063E6C" }}>{this.state.items.length}</b>{" "}
            <Trans>clips</Trans>
          </div>
          <div style={{ flex: "1" }}></div>
          <ToggleButtonGroup
            size="small"
            value={this.state.filter}
            exclusive
            onChange={this.handleChange}
          >
            <ToggleButton value=""><Trans>All</Trans></ToggleButton>
            <ToggleButton value="PROCESSING"><Trans>Processing</Trans></ToggleButton>
            <ToggleButton value="PROCESSED"><Trans>Finished</Trans></ToggleButton>
            <ToggleButton value="ERROR"><Trans>Error</Trans></ToggleButton>
          </ToggleButtonGroup>
          <div style={{ width: "16px" }}></div>
          <IconButton onClick={this.toggleView.bind(this)} title="Change Display" size="large">
            {this.state.display === "grid" ? <ReorderIcon /> : <AppsIcon />}
          </IconButton>
        </WideContainer>
      </div>
      <WideContainer>
        <div className="videoContainer">
          {this.state.loading && (
            <CircularProgress
              style={{ margin: "24px auto", display: "block" }}
            />
          )}

          {this.state.filtered.map((i, k) => (
            <React.Fragment key={"clip-" + i.video_id}>
              {this.state.display === "grid" && (
                <div className="videoDiv" key={"clip" + k}>
                  {"thumbnail_path" in i && i.thumbnail_path !== null ? (
                    <a href={i.download_path} target="_blank" rel="noopener noreferrer">
                      <div>
                        <img src={i.thumbnail_path} alt="Video Thumbnail" className="videoThumbImg" />
                      </div>
                    </a>
                  ) : (
                    <div className="videoThumb">{this.getIcon(i)}</div>
                  )}

                  <div style={{ padding: "10px 8px 8px 16px" }}>
                    <div className="videoNameGrid">{i.video_name}</div>
                    <div className="flex">
                      <div className="videoDateGrid">
                        {this.formatFields(i.created_time_z, "created_at")}
                      </div>
                      <a
                        href={
                          i.download_path +
                          '?response-content-disposition=attachment;%20filename="' +
                          encodeURIComponent(i.video_name) +
                          this.getFormat(i.download_path) +
                          '"'
                        }
                        target="_blank" rel="noopener noreferrer"
                        className="noUnderline"
                      >
                        <Button
                          hidden={i.status !== "PROCESSED"}
                          className="Button"
                          size="small"
                          endIcon={
                            <GetAppIcon style={{ color: "#1355b2" }} />
                          }
                        >
                          <Trans>Download</Trans>
                        </Button>
                      </a>
                      <IconButton
                        size="small"
                        onClick={this.menuClick.bind(this, i.video_id)}
                      >
                        <MoreVertIcon fontSize="inherit" />
                      </IconButton>
                    </div>
                  </div>
                </div>
              )}
            </React.Fragment>
          ))}
          {this.state.display === "grid" && (
            <>
              <div className="videoDiv" style={{ opacity: 0 }} />
              <div className="videoDiv" style={{ opacity: 0 }} />
              <div className="videoDiv" style={{ opacity: 0 }} />
            </>
          )}
        </div>
        {this.state.display === "table" && (
          <>
            <div className="videoHr"></div>
            {this.state.filtered.map((i, k) => (
              <a
                disabled={i.status !== "PROCESSED"}
                href={i.status === "PROCESSED" ? i.download_path : "#"}
                className="noUnderline videoLink"
                download
                target="_blank" rel="noopener noreferrer"
                key={"clipl" + i.video_id}
              >
                <div className="flex videoRow" key={"clip" + k}>
                  <div className="videoName">{i.video_name}</div>
                  <div className="videoDesc">
                    {this.formatFields(i.created_time_z, "created_at")}
                  </div>
                  <div className="videoDuration">{i.duration}</div>
                  <div className="videoStatus">
                    {this.formatFields(i.status, "status")}
                  </div>
                  <div className="videoIcon">
                    {this.formatFields(i.status, "icon")}
                  </div>
                  <IconButton onClick={this.menuClick.bind(this, i.video_id)} size="large">
                    <MoreVertIcon />
                  </IconButton>
                </div>
              </a>
            ))}
            <div style={{ height: "16px" }}></div>
          </>
        )}
      </WideContainer>
      <Menu
        anchorEl={this.state.menuAnchor}
        open={Boolean(this.state.menuAnchor)}
        onClose={this.menuClose.bind(this)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={this.downloadThumbnail.bind(this)}>
          <Trans>Download Best Frame</Trans>
        </MenuItem>
        <MenuItem onClick={this.deleteProject.bind(this)}><Trans>Delete</Trans></MenuItem>
      </Menu>
    </>);
  }
}

export default withTranslation()(Index);
